interface PersonalDevelopmentProps {
  personal_development: {
    technologies: Array<{
      category: string;
      items: string[];
    }>;
  };
}

export function PersonalDevelopment({
  personal_development,
}: PersonalDevelopmentProps) {
  return (
    <section className="no-page-break">
      <h2 className="jp-heading break-after-avoid text-2xl print:text-xl font-black tracking-[0.04em] text-ink">
        習得技術（個人開発）
      </h2>
      <dl className="mt-6 print:mt-3 flex flex-col">
        {personal_development.technologies.map((group, index) => (
          <div
            key={index}
            className="grid gap-x-6 gap-y-2 border-t border-rule py-4 print:py-2 sm:grid-cols-[12rem_1fr] print:grid-cols-[10rem_1fr]"
          >
            <dt className="text-sm print:text-[12.5px] font-bold leading-7 print:leading-6 text-ink">
              {group.category}
            </dt>
            <dd>
              <ul className="flex flex-wrap gap-1.5">
                {group.items.map((item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="rounded-[3px] bg-tint px-2 py-0.5 text-[13px] print:text-[11.5px] text-ink-2"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
